// Update just the extractShopName function to check for manual names first
export const extractShopName = (
    url: string,
    collectionName?: string,
    userId?: string
  ): string => {
    // First check if there's a valid manually entered collection name
    if (
      collectionName &&
      collectionName !== `Collection_${userId}` &&
      !collectionName.startsWith("Collection_")
    ) {
      return collectionName;
    }
  
    // Fall back to existing URL extraction logic
    if (!url) return "Your Store";
    const pattern =
      /^(?:https?:\/\/)?(?:www\.)?([^.]+)(?:\.myshopify\.com|\.com|\.net|\.org)/i;
    const match = url.match(pattern);
    const name = match ? match[1] : "Your Store";
    return name.charAt(0).toUpperCase() + name.slice(1);
  };